import { axios } from "src/common/utils";
import authHeader from "src/common/auth/authHeader";

const AuthenService = {};

AuthenService.login = (userName, password) => {
  return new Promise((resolve, reject) => {
    axios({
      // headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/Auth/login`,
      data: {
        userName: userName,
        password: password,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

AuthenService.concurrentLogin = (userName, password, isDuplicated) => {
  return new Promise((resolve, reject) => {
    axios({
      // headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_AUTH_SERVICE}/api/Auth/ConcurrentToken`,
      data: {
        userName: userName,
        password: password,
        isDuplicated: isDuplicated,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

AuthenService.getOnetimeToken = (appCode, appRediectUrl) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_AUTH_SERVICE}/api/Auth/GetOnetimeToken`,
      data: {
        appCode: appCode,
        appRediectUrl: appRediectUrl || "",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

AuthenService.LoginHandShake = (handCheckReq) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_SERVICE}/api/Auth/loginHandShake`,
      data: {
        token: handCheckReq.token,
        fromSystem: handCheckReq.fromSystem,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
AuthenService.GSSLoginHandShake = (handCheckReq) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_SERVICE}/api/GSS/loginHandShake`,
      data: {
        token: handCheckReq.token,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
AuthenService.LoginHandShakeGSS = (handCheckReq) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_AUTH_SERVICE}/api/Auth/loginHandShakeGSS`,
      data: {
        token: handCheckReq.token,
        fromSystem: handCheckReq.fromSystem,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

AuthenService.clearToken = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_AUTH_SERVICE}/api/Auth/ClearToken`,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export default AuthenService;
